import { Button, HFlow, Modal, ModalBody, ModalFooter, ModalHeader, Text } from 'bold-ui'
import React from 'react'

interface ModalCancelarSolicitacaoProps {
  isModalOpen: boolean
  setIsModalOpen(isOpen: boolean): void
  solicitacaoId: string
  onCancelarSolicitacao(solicitacaoId: string): void
}

export const ModalCancelarSolicitacao = (props: ModalCancelarSolicitacaoProps) => {
  const { isModalOpen, setIsModalOpen, solicitacaoId, onCancelarSolicitacao } = props
  const handleFecharModal = () => setIsModalOpen(false)
  const handleCancelarSolicitacao = () => {
    onCancelarSolicitacao(solicitacaoId)
    handleFecharModal()
  }

  return (
    <Modal open={isModalOpen} onClose={handleFecharModal} size='small' closeOnBackdropClick={true}>
      <ModalHeader title='Deseja cancelar a solicitação de envio?' icon={{ name: 'infoCircleOutline', fill: 'info' }} />
      <ModalBody>
        <Text>
          Ao cancelar a solicitação de envio, os dados não serão enviados para a instalação central do município.
        </Text>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <Button kind='normal' onClick={handleFecharModal}>
            Não, continuar
          </Button>
          <Button kind='primary' onClick={handleCancelarSolicitacao}>
            Sim, cancelar
          </Button>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
